
var $ = require('jquery');
var statesConfig = statesConfig || require('../../js/data/states-config.js');

// ====================================
//  State Results Table
// ====================================

    class StateResultsTable
    {
        constructor(p_element)
        {
            this.element = null;

            this.candidates = [];
            this.items = [];

            if(p_element)
            {
                this.init(p_element);
            }
        }

        init(p_element)
        {
            if(p_element)
            {
                this.element = p_element;
                this.build();
            }
        }

        build()
        {
            this.createElements();
            
            this.buildHeader();
            this.buildStateRows();
        }

        createElements()
        {
            this.header = this.element.find('.cnn-delegate-roll-call--results-table--header');
            this.list = this.element.find('.cnn-delegate-roll-call--results-table--list');
        }

        buildHeader()
        {
            var headerRow = $('<div class="row"></div>');

            this.header.append(headerRow);

            headerRow.append("<h5 class='cnn-delegate-roll-call--results-table--header__title col-xl-8 col-lg-8 col-md-6 col-sm-4 col-xs-2'>Total delegates</h5>");
            this.candidates.push($("<div class='cnn-delegate-roll-call--results-table--header__candidate col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-1'></div>"));
            this.candidates.push($("<div class='cnn-delegate-roll-call--results-table--header__candidate col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-1'></div>"));

            headerRow.append(this.candidates)
        }

        buildStateRows()
        {
            statesConfig = statesConfig.sort( function(a, b) { return a.long > b.long ? 1 : a.long < b.long ? -1 : 0 } );

            $.each(statesConfig, $.proxy(function(id, val)
            {
                var newRow = $('<li class="cnn-delegate-roll-call--results-table--list__item"></li>');
                this.items.push( new StateResultsTable__Item(newRow, val) );
                this.list.append(newRow);
                
            }, this));
        }

        update(p_data)
        {
            if(p_data)
            {
                $.each(p_data, $.proxy(function(id, val)
                {
                    var candidate = getCandidateById(p_data[id]['id']),
                        candidateName = candidate['lname'].toLowerCase();

                    if(this.data)
                    {
                        if(parseInt(p_data[id]['id']) !== parseInt(this.data[id]['id']))
                        {
                            this.candidates.attr({ "class" : ("cnn-delegate-roll-call--results-table--header__candidate col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-1 " + candidateName) });

                            var image = this.candidates[id].find('img'),
                                title = this.candidates[id].find('h4');

                            title.html(candidateName);
                            image.attr({ 'src' :  process.env.CDN + '/media/images/' + candidateName + '.' + (candidateName == 'other' ? 'png' : 'jpg') })
                        }

                        var rd = this.candidates[id].find('[data-rd]');
                            rd.data({ 'rd' : parseInt(val[rd]) }).html( formatNumber(val['rd']) );
                    }
                    else
                    {
                        this.candidates[id].addClass(candidateName);
                        this.candidates[id].append("<div class='cnn-delegate-roll-call__image'><img class='cnn-delegate-roll-call__image__src' src='" + process.env.CDN + "/media/images/" + (candidateName + '.' + (candidateName == 'other' ? 'png' : 'jpg')) + "' /></div>");
                        this.candidates[id].append("<h4 class='cnn-delegate-roll-call__title'>" + candidateName + "</h4>");
                        this.candidates[id].append("<p class='cnn-delegate-roll-call--results-table--header__candidate__rd' data-rd='" + parseInt(val[rd]) + "'>" + formatNumber(val['rd']) + "</h4>");
                    }
                    
                }, this));
                
            }

            return p_data;
        }

        getItemById(p_id)
        {
            return $.grep(this.items, function(e){ return e['id'] == p_id; })[0];
        }

        get data()
        {
            return this._data;
        }

        set data(p_data)
        {
            this._data = this.update(p_data);
        }
    }

// ====================================
//  State Results Table -- Item
// ====================================


    class StateResultsTable__Item
    {
        constructor(p_element, p_config)
        {
            this._data = null;
            this.config = null;
            this.element = null;
            this.candidates = [];

            if(p_element && p_config)
            {
                this.init(p_element, p_config);
            }
        }

        init(p_element, p_config)
        {
            if(p_element, p_config)
            {
                this.element = p_element;
                this.config = p_config;
                this.build();
            }
        }

        build()
        {
            var resultsRow = $('<div class="row"></div>');

            this.element.append(resultsRow);

            resultsRow.append("<h5 class='cnn-delegate-roll-call--results-table--list__item__title col-xl-8 col-lg-8 col-md-6 col-sm-4 col-xs-2'>" + this.config['long'] + "</h5>");
            this.candidates.push($("<div class='cnn-delegate-roll-call--results-table--list__item__result col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-1'></div>"));
            this.candidates.push($("<div class='cnn-delegate-roll-call--results-table--list__item__result col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-1'></div>"));

            resultsRow.append(this.candidates);
        }

        update(p_data)
        {
            if(p_data)
            {
                var totalDelegates = parseInt(this.config['races'][0]['totalDelegates']);

                $.each(p_data, $.proxy(function(id, val)
                {
                    var candidate = getCandidateById(val['id']),
                        candidateName = candidate['lname'].toLowerCase(),
                        value = $("<p class='cnn-delegate-roll-call--results-table--list__item__result__value " + candidateName + "'>" + val['rd'] + "</p>"),
                        percent = parseInt(val['rd']) / totalDelegates;

                        this.candidates[id].html( value );

                }, this));
            }   

            return p_data;
        }

        get id()
        {
            return this.config !== null ? this.config["short"] : undefined;
        }

        get data()
        {
            return _data;
        }

        get name()
        {
            return this.config ? this.config['long'] ? this.config['long'] : "undefined" : "undefined";
        }

        set data(p_data)
        {
            this._data = this.update(p_data);
        }
    }

// ====================================
//  Helper Functions
// ====================================

    function formatNumber(p_num)
    {
        return p_num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    function showFullResults()
    {
        return CNN.interactive.roll_call.showFullResults;
    }

    function getData()
    {
        return CNN.interactive.roll_call.data;
    }

    function getOverlay()
    {
        return CNN.interactive.roll_call.overlay;
    }

    function getCandidateById(p_id)
    {
        return CNN.interactive.roll_call.getCandidateById(p_id);
    }

// ====================================
//  Exports
// ====================================

    exports.StateResultsTable = StateResultsTable;
    


/** WEBPACK FOOTER **
 ** ./src/js/mod/roll-call-mod--results-table.js
 **/